/**
 * Pages = nodes the user creates through the sidebar compose flow, surfaced in
 * the sidebar Notion-style. Tracked locally (per identity) as {id, title} so the
 * sidebar can show + live-rename them without a backend "is a page" flag, and
 * without re-fetching the whole node firehose. Emits `pages-changed` on writes.
 */
const keyFor = (uid) => `composer_pages_${uid || 'anon'}`;

export function getPages(uid) {
    try { return JSON.parse(localStorage.getItem(keyFor(uid)) || '[]'); } catch { return []; }
}

function savePages(uid, pages) {
    try { localStorage.setItem(keyFor(uid), JSON.stringify(pages)); } catch { /* ignore */ }
    window.dispatchEvent(new CustomEvent('pages-changed'));
}

export function upsertPage(uid, page) {
    const list = getPages(uid).filter(p => String(p.id) !== String(page.id));
    list.unshift({ id: page.id, title: page.title || 'New node' });
    savePages(uid, list);
}

export function updatePageTitle(uid, id, title) {
    const list = getPages(uid).map(p => (String(p.id) === String(id) ? { ...p, title } : p));
    savePages(uid, list);
}

export function removePage(uid, id) {
    savePages(uid, getPages(uid).filter(p => String(p.id) !== String(id)));
}
